import React, { useState, useEffect } from 'react';

const ToggleButton = ({ handleParams, params, paramName, paramValue, label, sub }) => {
  // Set the initial state of toggle based on url param.
  const [state, setState] = useState(() => {
    const keywords = params.get(paramName)?.split(',') ?? [];
    return keywords.includes(paramValue);
  });


  useEffect(()=>{
    const keywords = params.get(paramName)?.split(',') ?? []
    const isSet = keywords.includes(paramValue)

    // remove
    if ( isSet && !state ) {

      // filter out paramValue
      const newKeywords = keywords.filter(k => k !== paramValue)
      const newParams = new URLSearchParams( params.toString() )

      newKeywords.length > 0
          ? newParams.set(paramName, newKeywords.join(',') )
          : newParams.delete(paramName)

      handleParams(newParams)
      // add
    } else if( state && !isSet ) {

      const newKeywords = keywords
      newKeywords.push(paramValue)
      const newParams = new URLSearchParams(params.toString())

      newParams.set(paramName, newKeywords.join(',') )

      handleParams(newParams)

    }
  },[state])

  useEffect( () => {
    // const isSet = checkIsSet();
    const tmpKeywords =  params.get(paramName)?.split(',') ?? []

    if(tmpKeywords.includes(paramValue) !== state) {
      setState(tmpKeywords.includes(paramValue) )
    }
  },[params])

  return (
      <div className={`toggle-button-wrapper${state ? ' active' : ''} ${paramValue}`}>
        <button type="button" onClick={() =>{
          setState( !state )
        }}>
          <span className="label">{label}</span>
          <span className="description">{sub}</span>
        </button>
      </div>
  );
};

export default ToggleButton;